import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function Accordion({ title, body }) {
  return (
    <div className="accordion active">
      <div className="accordion__title">
        <FontAwesomeIcon className="icon" icon={['fas', 'chevron-down']} />{' '}
        {title}
      </div>
      <div className="accordion__body">{body}</div>
    </div>
  );
}
